import React from 'react';
import { useMutation } from 'react-query';
import { useServiceClient } from 'common';
import { SharedEndPoints, SharedReactQueryKey } from './query-enum';
import { IBinaryDataPayload, ISaveBinaryDataResponse } from './query-interfaces';

export const useSaveBinaryDataQuery = () => {
    const { postData } = useServiceClient();
    const saveBinaryData = React.useCallback((args: IBinaryDataPayload) =>
        postData(SharedEndPoints.SAVE_BINARY_DATA, args).then<ISaveBinaryDataResponse>((res) => res.json()).then((res) => ({ ...res, fileName: args.FileName }))
        , [postData]);
    return useMutation(SharedReactQueryKey.SAVE_BINARY_DATA, saveBinaryData);
};
